import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import creativeData from '../../data/creativeData.json';

const Team = () => {
  const getUserImage = (imageName) => {
    return require(`../../assets/user_images/${imageName}`)
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className="team-section py-5">
      <Container className="py-5">
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">OUR TEAM</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Creative Minds Behind Our Success
          </motion.h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4">
            {creativeData.team.map((member) => (
              <Col key={member.id} md={6} lg={3}>
                <motion.div variants={cardVariants}
                  whileHover={{ y: -10, transition: { duration: 0.3 } }}
                >
                  <Card className="border-0 shadow-sm rounded-4 overflow-hidden text-center h-100">
                    <div className="team-img-wrapper position-relative">
                      <Card.Img variant="top" src={getUserImage(member.image)} alt={member.name}/>
                      <div className="team-social position-absolute start-0 bottom-0 w-100 d-flex justify-content-center gap-2 pb-3 opacity-0">
                        <motion.div whileHover={{ scale: 1.1 }}>
                          <Button as="a" href={member.social.linkedin} size="sm" variant="light" className="rounded-circle">
                            <i className="ri-linkedin-fill"></i>
                          </Button>
                        </motion.div>
                        <motion.div whileHover={{ scale: 1.1 }}>
                          <Button as="a" href={member.social.twitter} size="sm" variant="light" className="rounded-circle">
                            <i className="ri-twitter-fill"></i>
                          </Button>
                        </motion.div>
                        <motion.div whileHover={{ scale: 1.1 }}>
                          <Button as="a" href={member.social.email} size="sm" variant="light" className="rounded-circle">
                            <i className="ri-mail-fill"></i>
                          </Button>
                        </motion.div>
                      </div>
                    </div>
                    <Card.Body>
                      <Card.Title as="h5" className="mb-1">{member.name}</Card.Title>
                      <p className="text-primary mb-0">{member.position}</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Team;
